export default class PageConfig {
  public static requestor = 'category-page-v3'
  public static developmentMode = process.env.NODE_ENV === 'development'
  public static tenant = process.env.UBIK_TENANT?.toLowerCase() || 'vistaprint'
}
